'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getStaticAssetUrl;

var _hubspot = require('hubspot.bender');

var _hubspot2 = _interopRequireDefault(_hubspot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStaticAssetUrl() {
  for (var _len = arguments.length, pathSegments = Array(_len), _key = 0; _key < _len; _key++) {
    pathSegments[_key] = arguments[_key];
  }

  return _hubspot2.default.staticDomainPrefix + '/' + pathSegments.join('/');
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-lib/static-1.28/js/urls/getStaticAssetUrl.js
// module id = 201
// module chunks = 0 1